import type { MpcStatisticsByDayLineDepartureRow } from './MpcStatisticsByDayLineDepartureRow';

export const IStatisticsServiceId = Symbol.for('IStatisticsService');

export interface IStatisticsService {
    getMpcStatistics(calendarDay?: string): Promise<any>;
    getMpcStatisticsByDayLineDeparture(from: string, to: string): Promise<MpcStatisticsByDayLineDepartureRow[]>;
    getExportUrl(from: string, to: string): string;
}
